export default {
      id: "rates-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#rates-usage",
      toString: function () {
        return this.url;
      }
    }